<template>
  <div v-if="resp && resp.detail" class="add-margin">
    <div class="S8 black-color top-title">
      {{ resp.detail.detail.title }}
    </div>
    <div class="S4 grey-color my-title">
      {{ resp.detail.detail.subTitle }}
    </div>
    <CourseVideoCatalog
      @playCourseVideo="playCourseVideo"
      @updateSwiper="updateSwiper"
      :contentHeight="contentHeight"
    />
  </div>
</template>

<script>
import CourseVideoCatalog from './CourseVideoCatalog'
import { mapActions, mapState } from 'vuex'
import util from '@/util/util'
import { hasPermission } from '@/api/permission'
export default {
  name: 'VideoDetail',
  components: {
    CourseVideoCatalog
  },
  data() {
    return {
      showDetail: true,
      contentHeight: -170
    }
  },
  mounted() {},
  computed: {
    ...mapState('video', ['resp'])
  },
  methods: {
    ...mapActions('video', ['requestVideo']),
    hasPermission,

    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },

    goManager() {
      util.go(
        `ycstock://managerDetail?managerId=${this.resp.detail.authorInfo.authorId}`
      )
    },

    playCourseVideo(course) {
      this.$emit('playCourseVideo', course)
    },

    updateSwiper() {
      this.$emit('updateSwiper')
    }
  }
}
</script>

<style scoped lang="scss">
.add-margin {
  margin: 0 32px;
}

.top-title {
  margin-top: 38px;
  margin-bottom: 16px;
}

.my-title {
  padding-bottom: 30px;
}
</style>
